import localStorageFacade from '@townsquare/facade/local-storage';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ThreadsV2_Query, {
	type ThreadsV2_Query as ThreadsV2_QueryType,
} from '../components/__generated__/ThreadsV2_Query.graphql';
import { PROMPT_OVERRIDE_KEY } from '../constants';

export const v2Resource = createRelayResource<ThreadsV2_QueryType>({
	getQuery: (_routerContext, resourceStoreContext) => {
		const context = resourceStoreContext as ResourceContext;

		const isEnabled = !!(
			fg('townsquare_enable_threads') &&
			context.collabContext?.rovoWorkspace &&
			context.user.accountId
		);

		const promptOverride = fg('townsquare_enable_threads_prompt_override')
			? (localStorageFacade.getItem(PROMPT_OVERRIDE_KEY) ?? undefined)
			: undefined;

		return {
			environment: getAggRelayEnvironment(),
			query: ThreadsV2_Query,
			variables: {
				cloudId: context.collabContext?.rovoWorkspace ?? '',
				experience: 'home-threads',
				homeThreadsInput: {
					userId: context.user.accountId ?? '',
					promptOverride: promptOverride,
				},
				isEnabled: isEnabled,
			},
		};
	},
});
